import {DvirGroup} from './dvir-group';
import {DvirItem} from './dvir-item';

export class DvirSection extends DvirItem {
  id?: number;
  title?: string;
  hasRemarks = false;

  groups: DvirGroup[] = [];

  constructor(groups: DvirGroup[]) {
    super();
    this.groups = groups;
  }

}
